import {
  selectIsConnectedToRoom,
  selectLocalPeerRole,
  useHMSActions,
  useHMSStore,
  useParticipantList,
} from '@100mslive/react-sdk';
import {useEffect, useState} from 'react';
import './App.css';
import {IBookedAppointment, IJoinMeetingObj, IMeeting, IMlov, IMlovByCategory, IMlovResponse} from './Zoom/interfaces';
import EdtechComponent from './ThemeComponents/EdtechComponent';
import './MeetingMsViewCss.css';
import {
  getAppointmentDetailById,
  getCareStudioMlovs,
  getClientHostToken,
  getClienttoken,
  getMeetingToekn,
  getShortLink,
} from './services/100-ms-services/ApiUtils';
import BaseService from './utils/BaseService';
import {getMlovByCategory, getMlovCodeFromId, getMlovListFromCategory, getMlovValueFromId} from './utils/CommonUtils';
import {APPOINTMENT_STATUS_CODES, MLOV_CATEGORY} from './100-ms-integration/common/constants';
import {ApolloProvider} from '@apollo/client';
import ApolloClient from './services/ApolloClient';
import { onError } from '@apollo/client/link/error';
import FontsStyle from './FontsStyle';

function App() {
  const [stateData, setStateData] = useState({
    roomState: 'Preview',
    errorMessage: '',
  });
  const [authTokenObj, setAuthTokenObj] = useState({
    name: '',
    authToken: '',
    meetingUrl: '',
    accountId: '',
  });
  const searchParam = window.location.search;
  const token = searchParam ? searchParam.replaceAll('?token=', '') : 'invalid';
  const {roles, participantsByRoles, peerCount} = useParticipantList();
  const hmsStore = useHMSStore(selectLocalPeerRole);
  console.log(roles, participantsByRoles, peerCount);

  const decoded: string = token ? window.atob(decodeURIComponent(token as string) as string) : '';
  let meetingObj = decoded?.length
    ? (JSON.parse(decoded) as any)
    : ({} as any);
  const decodedAuthToken: string = meetingObj?.authToken ? window.atob(decodeURIComponent(meetingObj?.authToken.split(".")[1] as string) as string) : '' as any
  const decodedAuthTokenObj =  decodedAuthToken?.length
    ? (JSON.parse(decodedAuthToken) as any)
    : ({} as any);
  const meetingIdViaAuthToken = decodedAuthTokenObj.meetingId 
  
  meetingObj = {
    ...meetingObj,
    accountUuid:
      meetingObj?.appointmentDetails?.accountUUID ??
      meetingObj.accountUUID ??
      meetingObj.accountUuid,
    meetingId: meetingObj?.meetingId ?? meetingObj?.id ?? meetingIdViaAuthToken,
  };
  const handleMeetingStart = () => {
    if (
      peerCount > 1 &&
      peerCount < 3 &&
      hmsStore?.name === 'role-doc' &&
      meetingObj.appointmentDetails &&
      meetingObj.appointmentDetails.startMeetingHook
    ) {
      const axios = BaseService.getSharedInstance().axios;
      axios
        .put(
          meetingObj.appointmentDetails.startMeetingHook,
          {
            eventName: 'START',
          },
          {
            headers: {
              'x-hasura-admin-secret': meetingObj.appointmentDetails.secret,
              'account-uuid': meetingObj.appointmentDetails.accountUUID,
            },
          }
        )
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const careStudioMlovs = async (meetingObj: any) => {
    const accountUUID = meetingObj?.appointmentDetails?.accountUUID;
    const mlovQueryObj = {
      operationName: 'getAllCareMlovsWithCategory',
      variables: {},
      query: 'query getAllCareMlovsWithCategory { mlovs { categoryId code id value isDeleted } mlovCategories { category id  } }'
    };
    const mlovResponse: any = await getCareStudioMlovs(mlovQueryObj, accountUUID);
    return getMlovByCategory(mlovResponse?.data?.data || {});
  };

  const getAppointmentDetailsFromDecodeData = async (meetingObj: any) => {
    if (meetingObj?.appointmentDetails?.appointmentId) {
      const appointmentDetailObj = {
        operationName: 'GetBookedAppointments',
        variables: {
          appointmentId: meetingObj?.appointmentDetails?.appointmentId,
        },
        query: 'query GetBookedAppointments($appointmentId: String!) { appointments: getBookedAppointments(params: {id: $appointmentId}) {   id   name   startDateTime   endDateTime   proposedTime   declinedReason   reasonForVisit   participants {     id     user     patient     contact     statusId     isInitiator   }     statusId   reference   userPracticeLocationId   accountLocationId   isVirtualLocation   appointmentType {     id     eventName     locationType {       value       code     }     category {       code     }   } }}'
      };
      try {
        const accountUUID = meetingObj?.appointmentDetails?.accountUUID;
        const appointmentDetails = await getAppointmentDetailById(appointmentDetailObj, accountUUID);
        return appointmentDetails;
      } catch (error) {
        console.error('error in get appointment details ', error);
      }
    } else {
      console.error('appointment details not present in token ', JSON.stringify(meetingObj));
      return {} as any;
    }
  }

  const setPreviewDetails = async (meetingObj: any) => {
    if (meetingObj && meetingObj?.id) {
      const response = await getMeetingToekn(meetingObj);
      const meetingObjRes = response?.data;
      const name = meetingObjRes?.data?.name
        ? meetingObjRes?.data?.name
        : meetingObjRes?.data?.firstName || meetingObjRes?.data?.lastName
          ? `${meetingObjRes?.data?.firstName || '' + ' ' || ''}${meetingObjRes?.data?.lastName || ''
          }`
          : '';
      const otherName = meetingObj?.name
        ? meetingObj?.name
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName || '' + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: name || otherName || 'Guest',
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else if (meetingObj && meetingObj?.joineeType === 'GUEST') {
      const response = await getClienttoken(meetingObj);
      const meetingObjRes = response?.data;
      const name = meetingObjRes?.data?.name
        ? meetingObjRes?.data?.name
        : meetingObjRes?.data?.firstName || meetingObjRes?.data?.lastName
          ? `${meetingObjRes?.data?.firstName || '' + ' ' || ''}${meetingObjRes?.data?.lastName || ''
          }`
          : '';
      const otherName = meetingObj?.name
        ? meetingObj?.name
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName || '' + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: name || otherName || 'Guest',
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else if (meetingObj && meetingObj.meetingId) {
      const response = await getClientHostToken(meetingObj);
      const meetingObjRes = response?.data;
      const shortLink = await getShortLink(meetingObjRes?.data?.meetingUrl);
      if (meetingObjRes?.data?.clientToken) {
        setAuthTokenObj((prev) => {
          return {
            ...prev,
            authToken: meetingObjRes?.data?.clientToken,
            name: meetingObjRes?.data?.name || meetingObj.userName
            || 'Host',
            meetingUrl: shortLink,
            accountId: meetingObj?.accountId,
          };
        });
      } else {
        console.log('guest invalid flow', response);
        return;
      }
    } else {
      const shortLink = await getShortLink(meetingObj?.meetingUrl);
      const otherName = meetingObj?.userName
        ? meetingObj?.userName
        : meetingObj?.firstName || meetingObj?.lastName
          ? `${meetingObj?.firstName + ' ' || ''}${meetingObj?.lastName || ''}`
          : '';
      setAuthTokenObj((prev) => {
        return {
          ...prev,
          authToken: meetingObj.authToken,
          name: otherName || 'Guest',
          meetingUrl: shortLink,
          accountId: meetingObj?.accountId,
        };
      });
      // hmsActions.join(meetingObj);
    }
  }

  const validateAppointmentAndTokenDetails = (meetingObj: any, appointmentDetails: IBookedAppointment, mlovResponse: IMlovByCategory) => {
    if (isAppointmentIsCancel(appointmentDetails, mlovResponse)) {
      setStateData((prev) => {
        return {
          ...prev,
          errorMessage: 'This link is no longer valid as the meeting has been cancelled.',
        };
      });
      return false;
    } else {
      const userId = meetingObj?.appointmentDetails?.userId;
      if (userId) {
        const participants = appointmentDetails?.participants || [];
        const isValidMeetingUser = participants.some(participant => {
          return participant?.user?.id && userId && userId === participant.user.uuid;
        });
        if (!isValidMeetingUser) {
          setStateData((prev) => {
            return {
              ...prev,
              errorMessage: 'You are no longer a participant in this meeting.',
            };
          });
        }
        return isValidMeetingUser;
      }
    }
    return true;
  }

  const isAppointmentIsCancel = (appointmentDetails: IBookedAppointment, mlovResponse: IMlovByCategory) => {
    const mlovList = getMlovListFromCategory(mlovResponse, MLOV_CATEGORY.APPOINTMENT_STATUS);
    const appointmentStatusCode = getMlovCodeFromId(mlovList, appointmentDetails.statusId);
    return appointmentStatusCode && (appointmentStatusCode === APPOINTMENT_STATUS_CODES.DECLINED || appointmentStatusCode === APPOINTMENT_STATUS_CODES.CANCELLED);
  }

  const onPreview = async () => {
    if (token === 'invalid') {
      return;
    }
    const decoded: string = token ? window.atob(decodeURIComponent(token as string) as string) : '';
    const meetingObj = decoded?.length ? (JSON.parse(decoded) as any) : ({} as any);
    console.log(meetingObj);
    if (meetingObj?.appointmentDetails?.appointmentId) {
      const mlovs = await careStudioMlovs(meetingObj);
      const appointmentResponse = await getAppointmentDetailsFromDecodeData(meetingObj);
      let appointmentDetails: any = {};
      if (appointmentResponse?.data?.data?.appointments && appointmentResponse?.data?.data?.appointments?.length) {
        appointmentDetails = appointmentResponse?.data?.data?.appointments[0];
      }
      let isValidMeeting = false;
      if (appointmentDetails?.id) {
        isValidMeeting = validateAppointmentAndTokenDetails(meetingObj, appointmentDetails, mlovs);
        if (isValidMeeting) {
          setPreviewDetails(meetingObj);
        }
      } else {
        setPreviewDetails(meetingObj);
      }
    } else {
      setPreviewDetails(meetingObj);
    }
  };
  const hmsActions = useHMSActions();
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  useEffect(() => {
    localStorage.removeItem('foldAccessToken');
    getFoldAccessToken();
  }, []);

  const getFoldAccessToken = async () => {
    const axios = BaseService.getSharedInstance().axios;
    const response = await axios.post(
      `/crm-communication/meetms/fold-token`,
      meetingObj
    );
    const foldAccessToken = response?.data?.data?.foldAccessToken;
    if (foldAccessToken) {
      localStorage.setItem('foldAccessToken', foldAccessToken);
      onPreview();
      window.addEventListener("beforeunload", () => hmsActions.leave());
      window.addEventListener("onunload", () => hmsActions.leave());
    } else {
      console.log('error in fetching toast');
    }
  };

  useEffect(() => {
    setStateData((prev) => {
      return {
        ...prev,
        roomState: isConnected ? 'Connected' : 'Preview',
      };
    });
  }, [isConnected]);

  useEffect(() => {
    handleMeetingStart();
  }, [peerCount]);

  const errorLink = onError((data) => {
    //
  });

  return (
    <>
      {stateData.errorMessage && (
        <div style={{
          textAlign: 'center'
        }}> {stateData.errorMessage}</div>
      )}
      {!stateData.errorMessage && (
        <ApolloProvider client={ApolloClient.getClient(errorLink)}>
           <style type="text/css">{FontsStyle.fontsStyle}</style>
            <EdtechComponent
              stateData={stateData}
              authTokenObj={authTokenObj}
              onActionPerformed={() => {
                setStateData((prev) => {
                  return {
                    ...prev,
                    roomState: 'Connected',
                  };
                });
              }}
            />
        </ApolloProvider>
      )}
    </>
  );
}

export default App;
